(() => {
const key = 'sienna_recently_viewed_v1';
async function init(root) {
 if (root.dataset.ready) return;
 root.dataset.ready = 'true';
 const handle = root.dataset.productHandle;
 if (!handle) return;
 let history;
 try {
   const stored = JSON.parse(localStorage.getItem(key) || '[]');
   history = Array.isArray(stored) ? stored.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)).slice(0,20) : [];
   localStorage.setItem(key, JSON.stringify([handle,...history.filter(h=>h!==handle)].slice(0,20)));
 } catch { return; }
 const previous = [...new Set(history)].filter(h=>h!==handle).slice(0,6);
 if (!previous.length) return;
 await new Promise(resolve => {
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) { resolve(); return; }
  const observer = new IntersectionObserver(entries => {
   if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); resolve(); }
  }, { rootMargin: '600px 0px' });
  observer.observe(root.closest('.shopify-section') || root.parentElement);
 });
 if (!root.isConnected) return;
 const cards = await Promise.all(previous.map(async h => {
  try {
   const base = window.Shopify?.routes?.root || '/';
   const response = await fetch(base+'products/'+encodeURIComponent(h)+'?section_id=sienna-recently-viewed');
   if (!response.ok) return null;
   const doc = new DOMParser().parseFromString(await response.text(),'text/html');
   const template = doc.querySelector('template[data-recent-card]');
   return template?.content.querySelector('li')?.cloneNode(true) || null;
  } catch { return null; }
 }));
 const valid = cards.filter(Boolean);
 if (!root.isConnected || !valid.length) return;
 const slider = document.createElement('div');
 slider.className = 'slider-component-desktop';
 const list = document.createElement('ul');
 list.id = 'Slider-recent-'+root.dataset.productId;
 list.className = 'grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek';
 list.setAttribute('role','list');
 valid.forEach((card,index)=>{card.id='Slide-recent-'+root.dataset.productId+'-'+index;list.append(card);});
 slider.append(list);
 const controls = document.createElement('div');
 controls.className = 'slider-buttons';
 controls.innerHTML = '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Previous products">‹</button><div class="slider-counter caption"><span class="slider-counter--current">1</span> / <span class="slider-counter--total"></span></div><button type="button" class="slider-button slider-button--next" name="next" aria-label="Next products">›</button>';
 controls.querySelector('.slider-counter--total').textContent=String(valid.length);
 controls.querySelectorAll('button').forEach(b=>b.setAttribute('aria-controls',list.id));
 slider.append(controls);
 root.hidden=false;
 const fragment = document.createElement('template');
 fragment.innerHTML='<slider-component class="slider-component-desktop">'+slider.innerHTML+'</slider-component>';
 root.querySelector('[data-recent-mount]').append(fragment.content.cloneNode(true));
}
function scan(scope=document) { scope.querySelectorAll('[data-sienna-recent]').forEach(init); }
scan();
if (!window.siennaRecentListener) {
 window.siennaRecentListener=true;
 document.addEventListener('shopify:section:load',event=>scan(event.target));
}
})();
